import { useMutation } from 'react-query';
import getBaseUserInfo from 'API/handlers/user';
import utils from 'utils';

const useUserInfo = () => {
  const { mutate: refetchBaseUserInfo } = useMutation({
    mutationFn: getBaseUserInfo,
    onSuccess: ({ baseUserInfo }) => {
      const { authenticatedData } =
        utils.getLocalStorageByKey('authenticatedData');
      utils.setLocalStorage({
        authenticatedData: {
          ...authenticatedData,
          baseUserInfo,
        },
      });
    },
  });

  return { refetchBaseUserInfo };
};

export default useUserInfo;
